import React from "react";
import { Box, Typography, Container, Button } from "@mui/material";

import storyImg from "../assets/storyImg.png";
import teamImg from "../assets/teamFoto.jpeg";
import mapImg from "../assets/mappa.png";
import { useEffect } from "react";
const brown = "#6b4f3b";

export default function AboutUs() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {/* ================= HERO ================= */}
      <Box
        sx={{
          py: 14,
          textAlign: "center",
          backgroundImage: `url(${storyImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          color: "white",
        }}
      >
        {/* overlay per leggibilità */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "rgba(0,0,0,0.55)",
          }}
        />

        <Typography
          sx={{ position: "relative", zIndex: 2 }}
          fontSize={{ xs: 42, md: 64 }}
          fontWeight="bold"
        >
          Chi siamo
        </Typography>
      </Box>

      {/* ================= OUR STORY ================= */}
      <Container sx={{ py: 12 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            gap: 8,
          }}
        >
          {/* testo */}
          <Box flex={1}>
            <Typography variant="h4" fontWeight="bold">
              La nostra storia
            </Typography>

            <Typography
              sx={{ mt: 3, color: "text.secondary", lineHeight: 1.8 }}
            >
              Crush Café nasce come un luogo dove rallentare, incontrarsi e
              restare un po’ più a lungo. Dal caffè del mattino agli aperitivi
              serali, è cresciuto grazie alle persone, alle chiacchiere e al
              passaparola. Qui le conversazioni diventano amicizie e ogni visita
              crea un ricordo.
            </Typography>

            <Button
              variant="contained"
              onClick={() => (window.location.href = "/crush-coffee")}
              sx={{
                mt: 4,
                bgcolor: brown,
                borderRadius: 8,
                "&:hover": { bgcolor: "#4e3728" },
              }}
            >
              Scopri il menu
            </Button>
          </Box>

          {/* immagine */}
          <Box
            component="img"
            src={storyImg}
            sx={{
              flex: 1,
              width: "100%",
              borderRadius: 5,
              objectFit: "cover",
              boxShadow: "0 16px 40px rgba(0,0,0,0.15)",
            }}
          />
        </Box>
      </Container>

      {/* ================= TEAM ================= */}
      <Box sx={{ py: 10, textAlign: "center", bgcolor: "#fffaf5" }}>
        <Container>
          <Typography variant="h4" fontWeight="bold">
            Il nostro team
          </Typography>

          <Typography
            sx={{
              mt: 2,
              mb: 6,
              maxWidth: 650,
              mx: "auto",
              color: "text.secondary",
            }}
          >
            Un piccolo team appassionato che prepara ogni tazza con cura,
            attenzione e amore per i dettagli.
          </Typography>

          <Box
            component="img"
            src={teamImg}
            sx={{
              width: "100%",
              borderRadius: 5,
              boxShadow: "0 12px 36px rgba(0,0,0,0.15)",
            }}
          />
        </Container>
      </Box>

      {/* ================= LOCATION ================= */}
      <Container sx={{ py: 12 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 6,
            bgcolor: "#fafafa",
            borderRadius: 5,
            p: { xs: 4, md: 8 },
            alignItems: "center",
          }}
        >
          {/* testo */}
          <Box flex={1}>
            <Typography variant="h4" fontWeight="bold">
              Vieni a trovarci a Treviso
            </Typography>

            <Typography
              sx={{ mt: 3, color: "text.secondary", lineHeight: 1.7 }}
            >
              Passa per un caffè, una pausa di lavoro o un aperitivo con amici.
              Ti aspettiamo in un ambiente accogliente, perfetto per rilassarti
              o incontrare nuove persone.
            </Typography>

            <Button
              variant="contained"
              href="https://www.google.com/maps/dir/45.7112872,11.4902644/Bar+Pisa+da+Ale,+Via+Pisa,+4,+31100+Treviso+TV/@45.7131431,11.5383892,10z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x477937bf9b3f8491:0xb19ddd6f1cb2e84c!2m2!1d12.2381974!2d45.678421?entry=ttu&g_ep=EgoyMDI2MDIwNC4wIKXMDSoASAFQAw%3D%3D"
              sx={{
                mt: 4,
                bgcolor: brown,
                borderRadius: 8,
                "&:hover": { bgcolor: "#4e3728" },
              }}
            >
              Ottieni indicazioni
            </Button>
          </Box>

          {/* mappa */}
          <Box
            component="img"
            src={mapImg}
            sx={{
              flex: 1.4,
              width: "100%",
              borderRadius: 4,
              boxShadow: "0 12px 36px rgba(0,0,0,0.15)",
            }}
          />
        </Box>
      </Container>
    </>
  );
}
